export const GROUP_NAME_MAX_LENGTH = 40;
